// extracted by mini-css-extract-plugin
module.exports = {"mobileMenuNotification":"MobileMenuNotification_mobileMenuNotification__1SRdD"};